'use client';

import { c as _c } from "react/compiler-runtime";
import { useParseSearchParams } from '@repo/sdk/qs';
import { useEffect, useState } from 'react';
import { usePathname, useRouter } from '../adapters/next';
import type { ColumnFilter } from '../tanstack-table';
export const useTableFilters = () => {
  const $ = _c(11);
  const {
    parsedParams
  } = useParseSearchParams();
  let t0;
  if ($[0] !== parsedParams.filter) {
    t0 = () => Object.entries(parsedParams?.filter ?? {}).map(_temp);
    $[0] = parsedParams.filter;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [filters, setFilters] = useState(t0);
  const router = useRouter();
  const pathname = usePathname();
  let t1;
  if ($[2] !== filters || $[3] !== parsedParams.filter || $[4] !== pathname || $[5] !== router) {
    t1 = () => {
      const currentSearch = window.location.search.replace(/^\?/, "");
      const params = new URLSearchParams(currentSearch);
      filters.forEach(filter => {
        params.set(`filter[${filter.id}]`, `${filter.value}`);
      });
      const filtersToRemove = parsedParams.filter ? Object.keys(parsedParams.filter).filter(key_0 => !filters.some(filter_0 => filter_0.id === key_0)) : [];
      filtersToRemove.forEach(filter_1 => {
        params.delete(`filter[${filter_1}]`);
      });
      const nextSearch = params.toString();
      if (nextSearch === currentSearch) {
        return;
      }
      router.replace(`${pathname}?${nextSearch}`);
    };
    $[2] = filters;
    $[3] = parsedParams.filter;
    $[4] = pathname;
    $[5] = router;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== filters) {
    t2 = [filters];
    $[7] = filters;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] !== filters) {
    t3 = {
      filters,
      setFilters
    };
    $[9] = filters;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
function _temp(t0) {
  const [key, value] = t0;
  return {
    id: key,
    value
  };
}